/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './regimen-adverse-event.reducer';

export const RegimenAdverseEventDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const regimenAdverseEventEntity = useAppSelector(state => state.regimenAdverseEvent.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="regimenAdverseEventDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.regimenAdverseEvent.detail.title">RegimenAdverseEvent</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.regimenAdverseEvent.id">Id</Translate>
            </span>
          </dt>
          <dd>{regimenAdverseEventEntity.id}</dd>
          <dt>
            <span id="description">
              <Translate contentKey="tinyMedicRestApp.regimenAdverseEvent.description">Description</Translate>
            </span>
          </dt>
          <dd>{regimenAdverseEventEntity.description}</dd>
          <dt>
            <span id="monitoringParameters">
              <Translate contentKey="tinyMedicRestApp.regimenAdverseEvent.monitoringParameters">Monitoring Parameters</Translate>
            </span>
          </dt>
          <dd>{regimenAdverseEventEntity.monitoringParameters}</dd>
          <dt>
            <span id="mitigationStrategies">
              <Translate contentKey="tinyMedicRestApp.regimenAdverseEvent.mitigationStrategies">Mitigation Strategies</Translate>
            </span>
          </dt>
          <dd>{regimenAdverseEventEntity.mitigationStrategies}</dd>
          <dt>
            <span id="adverseEventInstructions">
              <Translate contentKey="tinyMedicRestApp.regimenAdverseEvent.adverseEventInstructions">Adverse Event Instructions</Translate>
            </span>
          </dt>
          <dd>{regimenAdverseEventEntity.adverseEventInstructions}</dd>
          <dt>
            <span id="severity">
              <Translate contentKey="tinyMedicRestApp.regimenAdverseEvent.severity">Severity</Translate>
            </span>
          </dt>
          <dd>{regimenAdverseEventEntity.severity}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.regimenAdverseEvent.active">Active</Translate>
            </span>
          </dt>
          <dd>{regimenAdverseEventEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.regimenAdverseEvent.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{regimenAdverseEventEntity.cursor}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.regimenAdverseEvent.lastUpdated">Last Updated</Translate>
            </span>
          </dt>
          <dd>{regimenAdverseEventEntity.lastUpdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.regimenAdverseEvent.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{regimenAdverseEventEntity.microSec}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.regimenAdverseEvent.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>{regimenAdverseEventEntity.timestampEntry}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.regimenAdverseEvent.regimen">Regimen</Translate>
          </dt>
          <dd>{regimenAdverseEventEntity.regimen ? regimenAdverseEventEntity.regimen.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.regimenAdverseEvent.drug">Drug</Translate>
          </dt>
          <dd>{regimenAdverseEventEntity.drug ? regimenAdverseEventEntity.drug.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.regimenAdverseEvent.adverseEffectType">Adverse Effect Type</Translate>
          </dt>
          <dd>{regimenAdverseEventEntity.adverseEffectType ? regimenAdverseEventEntity.adverseEffectType.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/regimen-adverse-event" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/regimen-adverse-event/${regimenAdverseEventEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default RegimenAdverseEventDetail;
